export const debounce = <T>(
  method: (...args: any[]) => T,
  ms: number,
): ((...args: any[]) => Promise<T>) => {
  let deferredResult: Promise<T>
  let timeout: ReturnType<typeof setTimeout>
  return async (...args: any[]): Promise<T> => {
    if (timeout) {
      clearTimeout(timeout)
    }
    deferredResult = new Promise((resolve) => {
      timeout = setTimeout(() => {
        resolve(method(...args))
      }, ms)
    })
    return deferredResult
  }
}
